import { fetchGet, rootApi, fetchPost } from '../helpers/api';

const graphApi = `${rootApi}/history-data`;

export const loadYearIndices = () => fetchGet(`${graphApi}/year-indices`);

const getLoadDataFunc = period => (stationId, timestamp) => fetchGet(`${graphApi}/${period}/${stationId}/${timestamp}`);

export const loadDayData = getLoadDataFunc('daily');
export const loadMonthData = getLoadDataFunc('monthly');
export const loadYearData = getLoadDataFunc('yearly');

export const loadGraphReferences = stationId => fetchGet(`${graphApi}/references/${stationId}`);

export const queryHistoryData = data => fetchPost(`${graphApi}/queryHistoryData`, data);